import { combineReducers } from "redux";
import uiReducer, { uiInitialState } from "./ui/slice";
import authUserReducer, { authUserInitialState } from "./auth-user/slice";
import dashboardReducer, {dashboardInitialState} from "./dashboard/slice";


export const initialState = {
  ui: uiInitialState,
  authUser: authUserInitialState,
  dashboard: dashboardInitialState,
};

export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    ui: uiReducer,
    authUser: authUserReducer,
    dashboard: dashboardReducer,
    ...injectedReducers,
  });

  return rootReducer;
}
